import { render, staticRenderFns } from "./MatchNameEdit.vue?vue&type=template&id=213811c6&"
import script from "./MatchNameEdit.vue?vue&type=script&lang=js&"
export * from "./MatchNameEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports